import React, { useRef } from "react";
import {
  TableRow,
  TableCell,
  Box,
  Avatar,
  Typography,
  Menu,
  MenuItem,
  Chip,
  useTheme,
} from "@mui/material";
import { makeStyles } from "tss-react/mui";
import AccountStatusChip from "./AccountStatusChip";
import MemberActionsMenu from "./MemberActionsMenu/MemberActionsMenu";
import { useSelector } from "react-redux";
import { getAvatarSx } from "../../../../../../DashboardLayout/Sidebar/SelectDomain";

const useStyles = makeStyles()((theme) => ({
  tableRow: {
    // "&:hover": {
    //   backgroundColor: theme.palette.action.hover,
    // },
    // cursor: "pointer",
    "&:last-child": {
      "& td": {
        borderBottom: "none",
      },
    },
  },
  tableCell: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
}));

function Member({
  user,
  handleUpdateUser,
  handleDeleteUser,
  roles,
  selectedUser,
  handleSelectUser,
}) {
  const { classes } = useStyles();
  const theme = useTheme();
  const { domains } = useSelector((state) => state.domain);
  const { id, name, email, role, status, access_domains, user_info } = user;
  const accountStatusRef = useRef(null);
  const open = selectedUser?.id === id;

  const handleClose = () => {
    handleSelectUser(null);
  };

  const handleChangeAccountStatus = async (status) => {
    await handleUpdateUser(id, { status });
    handleClose();
  };

  return (
    <TableRow className={classes.tableRow}>
      <TableCell
        className={classes.tableCell}
        style={{ minWidth: 400, maxWidth: 500 }}>
        <Box display="flex" alignItems="center" gap={1.5}>
          <Avatar src={user.avatar}>{getUserNameShortform(name)}</Avatar>
          <Box>
            <Typography variant="body2" fontWeight={500}>
              {name}
            </Typography>
            <Box mb={0.5} />
            <Typography variant="body2" color="text.secondary" fontSize={12}>
              {email}
            </Typography>
          </Box>
        </Box>
      </TableCell>
      <TableCell className={classes.tableCell}>
        {access_domains &&
        access_domains.domains &&
        access_domains.domains.length > 0 ? (
          <Box display={"flex"} gap={1}>
            {access_domains.domains.map((domainId) => {
              return (
                <Chip
                  key={domainId}
                  size="small"
                  label={
                    domains.find((domain, index) => domain.id === domainId)
                      ?.domain
                  }
                  sx={{
                    ...(theme.palette.mode !== "dark" &&
                      getAvatarSx(domains.findIndex((d) => d.id === domainId))),
                    ...(theme.palette.mode !== "dark" && { color: "white" }),
                    fontWeight: 500,
                    borderRadius: 1,
                  }}
                />
              );
            })}
          </Box>
        ) : (
          "--"
        )}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {user_info?.line
          ? user_info?.line.charAt(0).toUpperCase() + user_info?.line.slice(1)
          : "--"}
      </TableCell>
      <TableCell className={classes.tableCell}>
        {role ? role.charAt(0).toUpperCase() + role.slice(1) : "--"}
      </TableCell>
      <TableCell className={classes.tableCell}>
        <Box ref={accountStatusRef}>
          <AccountStatusChip status={status} />
        </Box>
        <Menu
          anchorEl={accountStatusRef.current}
          open={open}
          onClose={handleClose}
          slotProps={{ paper: { sx: { borderRadius: 2, mt: 0.5 } } }}>
          <MenuItem
            selected={status === "active"}
            onClick={() => handleChangeAccountStatus("active")}>
            Active
          </MenuItem>
          <MenuItem
            selected={status === "inactive"}
            onClick={() => handleChangeAccountStatus("inactive")}>
            Inactive
          </MenuItem>
        </Menu>
      </TableCell>
      <TableCell className={classes.tableCell} align="right">
        <Box onClick={(e) => e.preventDefault()}>
          <MemberActionsMenu
            user={user}
            handleUpdateUser={handleUpdateUser}
            handleDeleteUser={handleDeleteUser}
            handleSelectUser={handleSelectUser}
            roles={roles}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

export const getUserNameShortform = (name) => {
  if (!name) {
    return "U";
  }
  const arr = name.split(" ");
  if (arr.length > 1) {
    return `${arr[0][0]}${arr[1][0]}`.toUpperCase();
  }
  return name[0].toUpperCase();
};

export default Member;
